import { styles as r } from "./styles.js";
const C = (e) => e.charAt(0).toUpperCase() + e.slice(1), v = (e) => {
  const s = e.depth, t = e.groupingColumnId || "", n = e.getValue(t);
  return { nestingLevel: s, groupByColumn: t, groupValue: n };
}, y = (e, s) => {
  s((t) => {
    const n = t.findIndex((d) => d.id === e);
    if (n !== -1) {
      const o = !t[n].desc;
      return [
        { id: e, desc: o }
      ];
    } else
      return [{ id: e, desc: !1 }];
  });
}, f = (e, s, t, n) => {
  const d = document.createElement("div");
  Object.assign(d.style, r.dragGhost);
  const o = document.createElement("div");
  Object.assign(o.style, r.dragGhostText), o.innerText = t > 1 ? `${s} + ${t} ${n}` : s, document.body.appendChild(o);
  const m = Math.max(o.offsetWidth);
  document.body.removeChild(o);
  const a = document.createElement("div");
  if (Object.assign(a.style, {
    ...r.dragGhostStackContainer,
    width: `${m}px`
  }), t > 1)
    for (let i = t > 3 ? 3 : t; i > 0; i--) {
      const p = document.createElement("div");
      Object.assign(p.style, {
        ...r.dragGhostCard,
        top: `${i * 4}px`,
        left: `${i * 4}px`,
        zIndex: `${10 - i}`,
        width: "100%"
      }), a.appendChild(p);
    }
  const c = document.createElement("div");
  Object.assign(c.style, {
    ...r.dragGhostCard,
    ...r.dragGhostTopCard,
    top: "0",
    left: "0",
    zIndex: "10"
  });
  const g = document.createElement("div");
  Object.assign(g.style, r.dragGhostRow), g.innerHTML = `<span>${t > 1 ? `${s} + ${t - 1} ${n}` : s}</span>`;
  const h = document.createElement("div");
  Object.assign(h.style, r.dragGhostIconContainer), h.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="#1C5A4A">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"/>
        </svg>
    `, c.appendChild(g), a.appendChild(c), a.appendChild(h), d.appendChild(a), document.body.appendChild(d), e.dataTransfer.setDragImage(d, 20, 20), setTimeout(() => {
    document.body.removeChild(d);
  }, 0);
  const l = () => {
    e.currentTarget.style.opacity = "", e.currentTarget.style.background = "", e.currentTarget.removeEventListener("dragend", l);
  };
  e.currentTarget.addEventListener("dragend", l);
}, x = (e) => {
  const s = {};
  return e.getHeaderGroups().forEach((t) => {
    t.headers.forEach((n) => {
      if (n.id !== "expander" && !n.column.getIsGrouped()) {
        const d = document.querySelector(`[id="${n.id}"]`);
        d && (s[n.id] = d.getBoundingClientRect().width);
      }
    });
  }), s;
};
export {
  f as createDragGhost,
  C as formatColumnName,
  v as getGroupDetails,
  x as getHeaderWidths,
  y as handleSortingChange
};
